import { hasParentWithMatchingSelector } from '@/utils';

export default {
  methods: {
    setupListener(callback) {
      if (!this.onClick) {
        this.onClick = (e) => {
          if (!hasParentWithMatchingSelector(e.target, `.${this.$el.classList[0]}`)) {
            callback();
          }
        };
      }
      setTimeout(() => {
        document.addEventListener('click', this.onClick);
      }, 0);
    },
    removeListener() {
      document.removeEventListener('click', this.onClick);
    },
  },
};




// WEBPACK FOOTER //
// ./src/mixins/popup.js